import { NOTICE_KINDS as t } from "../notice/notice-constants.js";
const T = ["gradient", ...t], s = ["status", "alert"], a = 6e3, o = ["default", "alternate"], A = {
  TOAST_ROLES: s,
  TOAST_MIN_DURATION: a,
  TOAST_LAYOUTS: o,
  TOAST_ALTERNATE_KINDS: T
};
export {
  T as TOAST_ALTERNATE_KINDS,
  o as TOAST_LAYOUTS,
  a as TOAST_MIN_DURATION,
  s as TOAST_ROLES,
  A as default
};
//# sourceMappingURL=toast-constants.js.map
